import { ping } from "./utils";

ping();
